@for (segmento of segmentos(); track $index) {
  @switch (segmento.tipo) {
    @case ('markdown') {
      <div class="super-ejecutivo-markdown" [innerHTML]="segmento.html"></div>
    }
    @case ('grafica') {
      <app-super-ejecutivo-grafica [grafica]="segmento.grafica"></app-super-ejecutivo-grafica>
    }
    @case ('graficaInvalida') {
      <div class="super-ejecutivo-markdown-aviso" [title]="segmento.motivo">
        <mat-icon>bar_chart</mat-icon>{{ graficaNoValida }}
      </div>
    }
    @case ('graficaIncompleta') {
      <div class="super-ejecutivo-markdown-aviso">
        <mat-progress-spinner mode="indeterminate" diameter="14"></mat-progress-spinner>{{ graficaEnCamino }}
      </div>
    }
  }
}
